/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { IceRect } from '../../components/icemultimedia/IceMultimediaStroke';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { lodgemembershipsummary } from '../stats/lodgemembshipsummary';
import { reporttemplate } from './reporttemplate';
import { reportfilter } from './subs/reportfilter';
import { rptobject } from './subs/rptobject';
import { rptsection } from './subs/rptsection';

export enum Report_Layout_Type {
  rltSectionLayout = 10,
  rltStaticLayout = 20,
};

export enum Report_Mode_Type {
  modeDesign = 0,
  modePreview = 1,
  modePrint = 2
};

export enum ReportSectionTypes {
  secReportHeader = 0,
  secPageHeader = 1,
  secSortHeader1 = 2,
  secSortHeader2 = 3,
  secSortHeader3 = 4,
  secDetail = 5,
  secSortFooter1 = 6,
  secSortFooter2 = 7,
  secSortFooter3 = 8,
  secPageFooter = 9,
  secReportFooter = 10
};

export enum Report_Page_Sizes {
  ps8_5_by_11 = 0,
};

export enum Report_Orientation {
  orPortrait = 0,
  orLandscape = 1,
};

export enum Report_Alignment {
  alignLeft,
  alignRight,
  alignCenter,
  alignTop,
  alignBottom,
  alignMiddle
};

export enum Report_Border_Style {
  bstyleNone,
  bstyleThin,
  bstyleMedium,
  bstyleThick
};

export enum ReportStandard_Logfonts {
  slfArialReg = 0,
  slfArialBld = 1,
  slfArialRegItalic = 2,
  slfArialBldItalic = 3,
  slfCourierNewReg = 4,
  slfCourierNewBld = 5,
  slfCourierNewRegItalic = 6,
  slfCourierNewBldItalic = 7,
};

export enum ReportKeyTypes {
  ktNone,
  ktPrimary,
  ktForeign,
  ktIndexed,
};

export enum ReportBarCodeType {
  TypeNone = 0,
  Standard1D_Code128 = 100,
  Standard1D_Code39 = 101,
  Standard1D_Code93 = 102,
  DataMatrix_20 = 220,
  DataMatrix_32 = 232,
  DataMatrix_48 = 248,
};

export enum ReportSystemFieldTypes {
  sysNone,
  sysPageNumber,
  sysRecordCount,
  sysDate,
  sysTime,
  sysDateTime,
};

export enum ReportDataTypes {
  dtText = 0,
  dtNumber = 1,
  dtDouble = 2,
  dtDateTime = 3,
  dtBoolean = 4,
};

export enum ReportFormats {
  mfNone = 0,
  mf9999 = 1,
  mf9_999 = 2,
  mf9_999_00 = 3,
  mf9_999_000 = 4,
  mf9_999_0000 = 5,
  mfMM_DD_YYYY = 6,
  mfYYYY = 7,
  mfHH_MM_SS = 8
};

export enum ReportSortTypes {
  stAsc,
  stDesc,
};

export enum ReportObjectType {
  otNone = 0,
  otObject = 1,
  otTextField = 2,
  otDataField = 3,
  otSystemField = 4,
  otParameterField = 5,
  otFormulaField = 6,
  otSummationField = 7,
  otPicture = 8,
  otGrouped = 9,
  otCompanyField = 10,
  otCustomField = 11,
};

export class reportObject extends rptobject {

  constructor(attr: any) {
    super(attr);
  }

  getType(): ReportObjectType {
    let ret = ReportObjectType.otNone;
    let typ = this.getStringValue(this.attributes, "TYPE");
    switch (typ) {
      case "OBJECT": ret = ReportObjectType.otObject; break;
      case "TEXTFIELD": ret = ReportObjectType.otTextField; break;
      case "DATAFIELD": ret = ReportObjectType.otDataField; break;
      case "SYSTEMFIELD": ret = ReportObjectType.otSystemField; break;
      case "PARAMETERFIELD": ret = ReportObjectType.otParameterField; break;
      case "FORMULAFIELD": ret = ReportObjectType.otFormulaField; break;
      case "SUMMATIONFIELD": ret = ReportObjectType.otSummationField; break;
      case "PICTURE": ret = ReportObjectType.otPicture; break;
      case "GROUPED": ret = ReportObjectType.otGrouped; break;
      case "COMPANYFIELD": ret = ReportObjectType.otCompanyField; break;
      case "CUSTOMFIELD": ret = ReportObjectType.otCustomField; break;
    }
    return ret;
  }
  getAlignType(): Report_Alignment {
    let ret = Report_Alignment.alignLeft;
    let atyp = this.getStringValue(this.attributes, "ALIGNTYPE");
    switch (atyp) {
      case "LEFT": ret = Report_Alignment.alignLeft; break;
      case "RIGHT": ret = Report_Alignment.alignRight; break;
      case "CENTER": ret = Report_Alignment.alignCenter; break;
      case "TOP": ret = Report_Alignment.alignTop; break;
      case "BOTTOM": ret = Report_Alignment.alignBottom; break;
      case "MIDDLE": ret = Report_Alignment.alignMiddle; break;
    }
    return ret;
  }
  getBorderStyle(): Report_Border_Style {
    let ret = Report_Border_Style.bstyleNone;
    ret = <Report_Border_Style>this.getLongValue(this.attributes, "BORDERSTYLE");
    return ret;
  }
  getBorders(): IceRect {
    let ret: IceRect = new IceRect();
    ret.left = this.getLongValue(this.attributes, "BORDERLEFT");
    ret.right = this.getLongValue(this.attributes, "BORDERRIGHT");
    ret.top = this.getLongValue(this.attributes, "BORDERTOP");
    ret.bottom = this.getLongValue(this.attributes, "BORDERBOTTOM");
    return ret;
  }
  getX(): number {
    let ret: number = 0;
    ret = this.getDoubleValue(this.attributes, "X");
    return ret;
  }
  getY(): number {
    let ret: number = 0;
    ret = this.getDoubleValue(this.attributes, "Y");
    return ret;
  }
  getWidth(): number {
    let ret: number = 0;
    ret = this.getDoubleValue(this.attributes, "WIDTH");
    return ret;
  }
  getHeight(): number {
    let ret: number = 0;
    ret = this.getDoubleValue(this.attributes, "HEIGHT");
    return ret;
  }
  getBorderColor(): string {
    let ret: string = "";
    ret = this.getStringValue(this.attributes, "BORDERCOLOR");
    return ret;
  }
  getBackColor(): string {
    let ret: string = "";
    ret = this.getStringValue(this.attributes, "BACKCOLOR");
    return ret;
  }
  getScaleToFit(): boolean {
    let ret: boolean = true;
    ret = this.getBoolValue(this.attributes, "SCALETOFIT");
    return ret;
  }
  getImageData(): string {
    return this.getStringValue(this, "innerdata");
  }
  getSection(): string {
    return this.getStringValue(this.attributes, "SECTION");
  }
  getData(): string {
    return this[super.gettablename().toLowerCase()];
  }
  setData(data: string): void {
    this[super.gettablename().toLowerCase()] = data;
  }

  // Implementation
  //CPen * GetPen() { return & m_pen; }
  //CBitmap * GetImage() { return & externalImage; }

  //CPen m_pen;
  //CBitmap externalImage;
  //CString externalImageData;
}

export class reportField extends reportObject {
  constructor(attr: any) {
    super(attr);
  }

  getFontName(): string {
    return this.getStringValue(this.attributes, "FONTNAME");
  }
  getFontSize(): string {
    return this.getStringValue(this.attributes, "FONTSIZE");
  }
  getFontItalic(): boolean {
    return this.getBoolValue(this.attributes, "FONTITALIC");
  }
  getFontBold(): boolean {
    return this.getBoolValue(this.attributes, "FONTBOLD");
  }
  getWrap(): boolean {
    return this.getBoolValue(this.attributes, "WRAPTEXT");
  }
  getFormat(): ReportFormats {
    let ret = ReportFormats.mfNone;
    let typ = this.getStringValue(this.attributes, "FORMAT");
    switch (typ) {
      case "MF9999": ret = ReportFormats.mf9999; break;
      case "MF9_999": ret = ReportFormats.mf9_999; break;
      case "MF9_999_00": ret = ReportFormats.mf9_999_00; break;
      case "MF9_999_000": ret = ReportFormats.mf9_999_000; break;
      case "MF9_999_0000": ret = ReportFormats.mf9_999_0000; break;
      case "MFMM_DD_YYYY": ret = ReportFormats.mfMM_DD_YYYY; break;
      case "MFYYYY": ret = ReportFormats.mfYYYY; break;
      case "MFHH_MM_SS": ret = ReportFormats.mfHH_MM_SS; break;
    }
    return ret;
  }
  getDataType(): ReportDataTypes {
    let ret: ReportDataTypes = ReportDataTypes.dtText;
    let dtyp = this.getStringValue(this.attributes, "DATATYPE");
    switch (dtyp) {
      case "DTTEXT": ret = ReportDataTypes.dtText; break;
      case "DTNUMBER": ret = ReportDataTypes.dtNumber; break;
      case "DTDOUBLE": ret = ReportDataTypes.dtDouble; break;
      case "DTDATETIME": ret = ReportDataTypes.dtDateTime; break;
      case "DTBOOLEAN": ret = ReportDataTypes.dtBoolean; break;
    }
    return ret;
  }
  getHandWriting(): boolean {
    return this.getBoolValue(this.attributes, "HANDWRITING");
  }

  //CFont m_font;
  //CBitmap m_handwriting_diagram;
}

export class reportDataField extends reportField {
  constructor(attr: any) {
    super(attr);
  }
  getKeyType(): ReportKeyTypes {
    let ret: ReportKeyTypes = ReportKeyTypes.ktNone;
    let dtyp = this.getStringValue(this.attributes, "KEYTYPE");
    switch (dtyp) {
      case "KTPRIMARY": ret = ReportKeyTypes.ktPrimary; break;
      case "KTFOREIGN": ret = ReportKeyTypes.ktForeign; break;
      case "KTINDEXED": ret = ReportKeyTypes.ktIndexed; break;
    }
    return ret;
  }
  getTableName(): string {
    return this.getStringValue(this.attributes, "TABLENAME");
  }
  getColumnName(): string {
    return this.getStringValue(this.attributes, "COLUMNNAME");
  }
  getFullName(): string {
    return this.getTableName() + "." + this.getColumnName();;
  }
  getDisplayName(): string {
    return this.getStringValue(this.attributes, "DISPLAYNAME");
  }
  getBarCodeType(): ReportBarCodeType {
    let ret: ReportBarCodeType = ReportBarCodeType.TypeNone;    
    let typ = this.getStringValue(this.attributes, "BARCODETYPE");
    switch (typ) {
      case "BARCODE-CODE128": ret = ReportBarCodeType.Standard1D_Code128; break;
      case "BARCODE-CODE39": ret = ReportBarCodeType.Standard1D_Code39; break;
      case "BARCODE-CODE93": ret = ReportBarCodeType.Standard1D_Code93; break;
      case "BARCODE-DM20X20": ret = ReportBarCodeType.DataMatrix_20; break;
      case "BARCODE-DM32X32": ret = ReportBarCodeType.DataMatrix_32; break;
      case "BARCODE-DM48X48": ret = ReportBarCodeType.DataMatrix_48; break;
    }
    return ret;
  }
  getBarcodeShowText(): boolean {
    return this.getBoolValue(this.attributes, "BARCODESHOWTEXT");
  }

  static parseTableName(tableColumnName: string): string {
    let ret: string = "";
    if (tableColumnName == null) return "";
    let parts = tableColumnName.split(".");
    return parts.length > 1 ? parts[0] : "";
  }

  static parseColumnName(tableColumnName: string): string {
    let ret: string = "";
    if (tableColumnName == null) return "";
    let parts = tableColumnName.split(".");
    return parts.length > 1 ? parts[1] : "";
  }
}

export class reportCompanyField extends reportDataField {
  constructor(attr: any) {
    super(attr);
  }
}

export class reportCustomField extends reportDataField {
  constructor(attr: any) {
    super(attr);
  }
}

export class reportTextField extends reportField {
  constructor(attr: any) {
    super(attr);
  }
}

export class reportSystemField extends reportField {
  constructor(attr: any) {
    super(attr);
  }

  getSystem(): ReportSystemFieldTypes {
    let ret: ReportSystemFieldTypes = ReportSystemFieldTypes.sysNone;
    let typ = this.getStringValue(this.attributes, "SYSTEM");
    switch (typ) {
      case "SYSPAGENUMBER": ret = ReportSystemFieldTypes.sysPageNumber; break;
      case "SYSRECORDCOUNT": ret = ReportSystemFieldTypes.sysRecordCount; break;
      case "SYSDATE": ret = ReportSystemFieldTypes.sysDate; break;
      case "SYSTIME": ret = ReportSystemFieldTypes.sysTime; break;
      case "SYSDATETIME": ret = ReportSystemFieldTypes.sysDateTime; break;
    }
    return ret;
  }

  static getSystemDescription(sysType: ReportSystemFieldTypes) {
    // Not needed
  }
}

export class reportSystemData {
  currentPageNumber: number = 0;
  pageMax: number = 0;
  currentRecordNumber: number = 0;
  dateTime: any = {};
  pageLimitY: number = 0;
  currentPageY: number = 0;
  currentPageStarting: number = 0.0;
  pixelsPerInch: number = 0;
  pageFooterPrinted: boolean = false;
  sort1Field: number = 0;
  sort2Field: number = 0;
  sort3Field: number = 0;
  recordsPerPage: number = 0;
  scale: number = 0.0;
  printJobMode: boolean = false;
  totalPrintJobs: number = 0;
  printJobCount: number = 0;
}

export class reportFormulaField extends reportDataField {
  constructor(attr: any) {
    super(attr);
  }
  
  getFormula(): string {
    return this.getStringValue(this.attributes, "FORMULA");
  }

  /*
// other
static const TCHAR szCONNECTORTYPE[]	= _T("CONNECTORTYPE");
static const TCHAR szCTNONE[]		= _T("CTNONE");
static const TCHAR szCTAND[]		= _T("CTAND");
static const TCHAR szCTOR[]			= _T("CTOR");

static const TCHAR szOPERATORTYPE[]		= _T("OPERATORTYPE");
static const TCHAR szOTEQUALTO[]	= _T("=");
static const TCHAR szOTGREATERTHAN[]= _T(">");
static const TCHAR szOTLESSTHAN[]	= _T("<");
static const TCHAR szOTGREATERTHANEQUALTO[]	= _T(">=");
static const TCHAR szOTLESSTHANEQUALTO[]	= _T("<=");
static const TCHAR szOTBETWEEN[]	= _T("BETWEEN");
static const TCHAR szOTIN[]			= _T("IN");
static const TCHAR szOTLIKE[]		= _T("LIKE");
  */
}

export class reportSummationField extends reportDataField {
  constructor(attr: any) {
    super(attr);
  }

  getHeaderValue(): any {
    let ret: any = null;
    // To do
    return ret;
  }

  getDetailValue(): any {
    let ret: any = null;
    // To do
    return ret;
  }
  getFooterValue(): any {
    let ret: any = null;
    // To do
    return ret;
  }
}

export class reportSection extends rptsection {
  objects: reportObject[] = [];
  printed: boolean = false;

  constructor(attr: any) {
    super(attr);
  }

  addObject(obj: reportObject): reportObject {
    this.objects.push(obj);
    return obj;
  }
  getObjectByPosition(dblX: number, dblY: number): reportObject {
    let ret: reportObject = null;
    // To do
    return ret;
  }
  getObjectCount(): number {
    return this.objects.length;
  }

  getObject(index: number): reportObject {
    if (index >= 0 && index < this.objects.length)
      return this.objects[index];

    return null;
  }

  resetObjects(): void {
    this.objects = null;
    this.objects = [];
  }

  getObjectsByY(y: number): reportObject[] {
    let ret: reportObject[] = [];
    for (let i = 0; i < this.objects.length; i++)
    {
      let obj: reportObject = <reportObject>this.objects[i];
      if (obj && obj.getY() == y) {
        ret.push(obj);
      }
    }
    return ret;
  }

  static getObjectType(obj: reportObject): ReportObjectType {
    let ret: ReportObjectType = obj.getType();
    return ret;
  }

  getSectionName(): string {
    return this.getStringValue(this.attributes, "SECTION");
  }

  getSortTableName(): string {
    return this.getStringValue(this.attributes, "TABLENAME");
  }
  getSortColumnName(): string {
    return this.getStringValue(this.attributes, "COLUMNNAME");
  }
  getSortFullName(): string {
    return this.getSortTableName() + "." + this.getSortColumnName();;
  }
  getShow(): boolean {
    let ret: boolean = true;
    ret = this.getBoolValue(this.attributes, "SHOW");
    return ret;
  }
  getHeight(): number {
    let ret: number = 0.0;
    ret = this.getDoubleValue(this.attributes, "HEIGHT");
    return ret;
  }
  getSortType(): ReportSortTypes {
    let ret: ReportSortTypes = ReportSortTypes.stAsc;
    let styp = this.getStringValue(this.attributes, "SORTTYPE");
    if (styp == "DESC")
      ret = ReportSortTypes.stDesc;
    return ret;
  }

  setPrinted(pnted: boolean = true): void {
    this.printed = pnted;
  }
  isPrinted(): boolean {
    return this.printed;
  }
};

export class reportJoin extends reportfilter {
  constructor() {
    super();
  }

  getRightOperandTableName(): string {
    let ret: string = "";
    // To do
    return ret;
  }
  getRightOperandColumnName(): string {
    let ret: string = "";
    // To do
    return ret;
  }
}

export class reportTrailer extends reportObject {
  rptObject: reportObject = null;

  constructor(attr: string[]) {
    super(attr);
  }

  getDisplayHandWritingFirstPage(): boolean {
    let ret: boolean = false;
    // To do
    return ret;
  }
  getTrailerData(): string {
    let ret: string = "";
    // To do
    return ret;
  }

  getReportObject(): reportObject {
    return this.rptObject;
  }
}

export class report extends IceEntity {
  attributes: any = {};
  public report_key: string = "";
  public report_type: IceTypes.ReportType = IceTypes.ReportType.rtClincialData;
  public src_type: IceTypes.SourceType = IceTypes.SourceType.srcUndefined;
  public sub_type: number = 0;
  public trans_account: string = "";
  public rpt_name: string = "";
  public rpt_desc: string = "";
  public dont_allow_change: boolean = false;
  public recurrence_key: string = "";
  public recurring_type: IceTypes.recurringtype = IceTypes.recurringtype.recurtypeOneTime;
  public record_version: number = 0;
  public offline_record_status: number = 0;
  public accessed: any = NaN;
  public accessed_user: string = "";
  public created: any = NaN;
  public created_user: string = "";
  public modified: any = NaN;
  public modified_user: string = "";

  RPTTEMPLATES: reporttemplate[] = [];
  LODGE_MEMBERSHIP_SUMMARY: lodgemembershipsummary[] = [];
	RPTSECTION: rptsection[] = [];
  RPTOBJECT: rptobject[] = [];

  sysdata: reportSystemData = null;
  outputSections: any = {};
  outputColumnDefinitions: any = {};
  outputColumns: string[] = [];
  outputRecords: Array<Array<any>> = [];

  outputSumFields: reportSummationField[] = [];
  outputFormulaFields: reportFormulaField[] = [];
  outputCompanyFields: reportCompanyField[] = [];

  public gettablename(): string {
    return "REPORT";
  }

  public hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "RPTTEMPLATES") return true;
    else if (ColumnName == "LODGE_MEMBERSHIP_SUMMARY") return true;
    else if (ColumnName == "RPTSECTION") return true;
    else if (ColumnName == "RPTOBJECT") return true;

    return false;
  }

  public getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "RPTTEMPLATES") return "REPORT_TEMPLATE";
    else if (ColumnName == "LODGE_MEMBERSHIP_SUMMARY") return "LODGE_MEMBERSHIP_SUMMARY";
    else if (ColumnName == "RPTSECTION") return "RPTSECTION";
    else if (ColumnName == "RPTOBJECT") return "RPTOBJECT";

    return null;
  }

  getReportName(): string {
    return this.getStringValue(this.attributes, "NAME");
  }

  //NAME="Packing List TTI" PAPERSIZE="0" DONTALLOWCHANGE="0" ORIENTATION="0" MARGINLEFT="0.25" MARGINRIGHT="0.25" MARGINTOP="0.25" MARGINBOTTOM="0.25" SRCTYPE="0" ONERECORDPERPAGE="0"
  getPaperSize(): Report_Page_Sizes {
    return <Report_Page_Sizes>this.getLongValue(this.attributes, "PAPERSIZE");
  }
  getOrientation(): Report_Orientation{
    return <Report_Orientation>this.getLongValue(this.attributes, "ORIENTATION");
  }
  getSourceType(): IceTypes.SourceType {
    return <IceTypes.SourceType>this.getLongValue(this.attributes, "SRCTYPE");
  }
  getOneRecordPerPage(): boolean {    
    return this.getBoolValue(this.attributes, "ONERECORDPERPAGE");
  }
  getMargins(): IceRect {
    let ret: IceRect = new IceRect();
    ret.left = this.getDoubleValue(this.attributes, "MARGINLEFT");
    ret.right = this.getDoubleValue(this.attributes, "MARGINRIGHT");
    ret.top = this.getDoubleValue(this.attributes, "MARGINTOP");
    ret.bottom = this.getDoubleValue(this.attributes, "MARGINBOTTOM");
    return ret;
  }

  getSectionByName(name: string): reportSection {
    if (name == null || name.length == 0) return null;

    let repSec: reportSection = this.outputSections[name];
    if (repSec != null) return repSec;

    for (let isec = 0; isec < this.RPTSECTION.length; isec++) {
      let sec = this.RPTSECTION[isec];
      if (sec == null) continue;

      let repSec: reportSection = new reportSection(sec.attributes);
      let secName = repSec.getSectionName();
      if (secName != null && secName.toLowerCase() == name.toLowerCase()) {
        this.outputSections[name] = repSec;
        return repSec;
      }
    }
    return null;
  }

  getSectionByType(type: ReportSectionTypes): reportSection {
    return this.getSectionByName(this.getSectionNameByType(type));
  }

  getSectionNameByType(type: ReportSectionTypes): string {
    let ret: string = "";
    switch (type) {
      case ReportSectionTypes.secReportHeader:
        return "Report Header";
      case ReportSectionTypes.secPageHeader:
        return "Page Header";
      case ReportSectionTypes.secSortHeader1:
        return "Sort Header 1";
      case ReportSectionTypes.secSortHeader2:
        return "Sort Header 2";
      case ReportSectionTypes.secSortHeader3:
        return "Sort Header 3";
      case ReportSectionTypes.secDetail:
        return "Detail";
      case ReportSectionTypes.secSortFooter1:
        return "Sort Footer 1";
      case ReportSectionTypes.secSortFooter2:
        return "Sort Footer 2";
      case ReportSectionTypes.secSortFooter3:
        return "Sort Footer 3";
      case ReportSectionTypes.secPageFooter:
        return "Page Footer";
      case ReportSectionTypes.secReportFooter:
        return "Report Footer";
    }
    return ret;
  }

  getReportDataField(tableColumn: string): reportDataField {
    let ret: reportDataField = null;
    for (let iobj = 0; iobj < this.RPTOBJECT.length; iobj++) {
      let obj = this.RPTOBJECT[iobj];
      if (obj == null) continue;

      let repObj: reportDataField = new reportDataField(obj.attributes);
      switch (repObj.getType()) {
        case ReportObjectType.otDataField: {
          if (tableColumn == repObj.getFullName())
            ret = repObj;
          break;
        }
      }
    }
    return ret;
  }

  getReportFieldIndex(tableColumn: string): number {
    // selection fields
    let ret = this.outputColumnDefinitions[tableColumn];
    if (ret == null) return -1;
    return ret;
  }

  initializeReport(): void {
    this.sysdata = new reportSystemData();
    this.outputSections = {};
    this.outputColumnDefinitions = {};
    this.outputColumns = [];
    this.outputRecords = [];

    for (let iobj = 0; iobj < this.RPTOBJECT.length; iobj++) {
      let obj = this.RPTOBJECT[iobj];
      if (obj == null) continue;

      let repObj: reportObject = new reportObject(obj.attributes);
      let secName = repObj.getSection();
      let sec: reportSection = this.getSectionByName(secName);
      switch (repObj.getType()) {
        case ReportObjectType.otObject: {
          sec.addObject(new reportObject(obj.attributes));
          break;
        }
        case ReportObjectType.otTextField: {
          sec.addObject(new reportField(obj.attributes))[obj.gettablename().toLowerCase()] = obj[obj.gettablename().toLowerCase()];
          break;
        }
        case ReportObjectType.otDataField: {
          let repDatObj = new reportDataField(obj.attributes);
          let tcName = repDatObj.getFullName();
          if (this.outputColumnDefinitions[tcName] == null) {
            let cIndex = this.outputColumns.push(tcName) - 1;
            this.outputColumnDefinitions[tcName] = cIndex;
          }

          sec.addObject(repDatObj);
          break;
        }
        case ReportObjectType.otSystemField: {
          sec.addObject(new reportSystemField(obj.attributes));
          break;
        }
        case ReportObjectType.otParameterField: {
          sec.addObject(new reportObject(obj.attributes));
          break;
        }
        case ReportObjectType.otFormulaField: {
          sec.addObject(new reportFormulaField(obj.attributes));
          break;
        }
        case ReportObjectType.otSummationField: {
          sec.addObject(new reportSummationField(obj.attributes));
          break;
        }
        case ReportObjectType.otPicture: {
          sec.addObject(new reportObject(obj.attributes));
          break;
        }
        case ReportObjectType.otGrouped: {
          sec.addObject(new reportObject(obj.attributes));
          break;
        }
        case ReportObjectType.otCompanyField: {
          sec.addObject(new reportCompanyField(obj.attributes));
          break;
        }
        case ReportObjectType.otCustomField: {
          sec.addObject(new reportCustomField(obj.attributes));
          break;
        }
      }
    }
  }
}
